<template>
    <div class="bg-white" id="DigitalFrontDoor" ref="top">
        <PrivacyPolicyBanner statement="Your personal information is never shared with your employer or L&G. Your data remains confidential and is used only to support your wellbeing."/>
        <HomeSessionsBanner/>
        <b-modal
          id="personalise-modal"
          v-bind:modal-class="'personalise-modal ' + getTheme()"
          @hidden="onModalHidden"
          hide-header
          hide-footer
          size="md"
          centered
        >
          <PersonaliseModal  :bannerData="personalisedBannerData"/>
        </b-modal>
        <FeaturesCarousel title="Featured" type="featured-event" v-if="products.wellbeingSeries"/>
        <CustomHomeSlider :items="services" :tile-type="'services'" v-if="services.length"/>
        <div v-if="messageToDisplay">
          <div class="container">
            <div v-html="messageToDisplay" class="homepageMessage"></div>
          </div>
        </div>
        <button v-if="isAllServicesBtnShown" class="view-services-btn" @click="() => $router.push('/services')">
          View all services
          <span class="arrow-container"><i class="fa fa-arrow-right" aria-hidden="true"></i></span>
        </button>
        <div class="pt-5 carousel-container">
            <HomeFilters />
            <HomeCardCarousel
                v-if="products.wellbeingSeries" :title="componentText.topEvents" type="studio" class="car" perma-tag="Top Events This Month" :mute="true"></HomeCardCarousel>
            <HomeCardCarousel
                v-if="products.wellbeingSeries" :title="'Upcoming Events'" type="studio" class="car" :upcoming="true"></HomeCardCarousel>
            <HomeCardCarousel
                v-if="showDcs" :title="'Book a Digital Clinic Service'" type="clinic" class="car"></HomeCardCarousel>
            <HomeCardCarousel
                promo-text="Watch expert speakers in a series of events and seminars"
                v-if="products.wellbeingSeries" title="Wellbeing Studio" class="car" type="studio" :mute="true"></HomeCardCarousel>
            <HomeCardCarousel
                promo-text="Health and wellbeing video courses"
                v-if="products.wellbeing" title="Courses" type="courses" class="car"></HomeCardCarousel>
            <HomeCardCarousel
                promo-text="Live and on-demand classes like yoga, Pilates and HIIT"
                v-if="products.digitalGym" title="Classes" type="gym" class="car"></HomeCardCarousel>
            <HomeCardCarousel
                promo-text="On-demand training plans to suit a range of fitness levels"
                v-if="products.digitalGym" title="Training Plans" type="exercise" class="car"></HomeCardCarousel>
            <HomeCardCarousel
                promo-text="Audio courses to help with sleep, anxiety, stress and more"
                v-if="products.beCalm" title="Be Calm" type="be_calm" class="car"></HomeCardCarousel>
            <HomeCardCarousel
                promo-text="Access new recipes and nutritional guides"
                v-if="products.nutrition" title="Nutrition" type="recipes" class="car"></HomeCardCarousel>
            <HomeCardCarousel
                promo-text="Listen to the latest podcasts in the world of wellbeing"
                v-if="products.soundSpace" title="Sound Space" type="Podcasts" class="car"></HomeCardCarousel>
        </div>
    </div>
</template>
<script>
import EapBanner from "@/components/Home/New/EapBanner.vue";
import HomeReminders from "@/components/Home/New/HomeReminders.vue"
import HomeCardCarousel from "@/components/Home/New/HomeCardCarousel.vue"
import HomeDigitalClinicsBanner from "@/components/Home/New/HomeDigitalClinicsBanner.vue"
import HomeFrontDoor from "@/components/Home/New/HomeFrontDoor.vue"
import HomeFilters from "@/components/Home/New/HomeFilters.vue"
import HomeEvents from "@/components/Home/New/HomeEvents.vue"
import { mapGetters } from "vuex";
import EventBus from "@/helpers/eventbus";
import ServicesDisplay from "@/components/Home/New/ServicesDisplay.vue";
import FeaturesCarousel from "@/components/Home/New/FeaturesCarousel.vue";
import CustomHomeSlider from "@/components/Home/New/CustomHomeSlider.vue";
import PrivacyPolicyBanner from "@/components/Home/New/PrivacyPolicyBanner.vue";
import HomeSessionsBanner from "@/components/Home/New/HomeSessionsBanner.vue";
import PersonaliseModal from "@/components/Home/PersonaliseModal.vue";
import axios from "axios";
import config from "../config/constants";

export default {
    components: {
      HomeSessionsBanner,
      PrivacyPolicyBanner,
        EapBanner,
        HomeCardCarousel,
        HomeDigitalClinicsBanner,
        HomeFrontDoor,
        HomeFilters,
        HomeEvents,
        HomeReminders,
        ServicesDisplay,
        FeaturesCarousel,
        CustomHomeSlider,
        PersonaliseModal
    },
    name: "DigitalFrontDoor",
    data() {
        return {
          bookings: [],
          services: [],
          bookingsLoading: true,
          displayWallet: false,
          optionalTag: null,
          company_homepage_message: null,
          personalisedBannerData: null,
          isAllServicesBtnShown: false,
          products: {
            wellbeingSeries: false,
            wellbeing: false,
            totalMentalHealth: false,
            soundSpace: false,
            nutrition: false,
            events: false,
            eap: false,
            digitalGym: false,
            digitalClinicsGeneric: false,
            beCalm: false,
          },
        };
    },
    async mounted() {
      const _t = this;
      EventBus.$on('updateDFDReminders',function() {
        _t.getBookings();
      });
      this.extractProductsFromNav(this.nav);
      this.extractProductsFromNav(this.sideNav);
      this.getServicesData();
      this.getBookings();
      this.getCompanyHomepageMessage();
      let self = this;
      EventBus.$on("setTag", function (tag) {
          if (tag) {
              self.optionalTag = [tag.tag];
          } else {
              self.optionalTag = [];
          }
      });
      this.getServices()
      await this.getPersonalisedBanner()
      EventBus.$on('showPersonalisedModal', this.openPersonaliseModal)
      if (this.$route.query.personalise_banner === 'true') {
        this.openPersonaliseModal();
      }
    },
    methods: {
      async getServices() {
        const payload = {
          user_id: this.$store.getters.user_id,
        }
        const res = await axios.post(config.api_env + '/application/api/u/marketplace/get-services', payload, config.options)
        if (res.data.success && res.data.services && res.data.services.length) {
          this.isAllServicesBtnShown = true
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
        }
      },
      async getCompanyHomepageMessage() {
        const res = await this.api({
          path: 'api/u/customisations/get-company-homepage-message'
        })
        if(res.success) {
          this.company_homepage_message = res.company_homepage_message;
        }
      },
      async getServicesData() {
        let res = await this.api({
          path: "api/u/home/get-front-door-banner",
        });
        if (res.success) {
          const services = [];
          res.banner.forEach(card => {
            let include = true;
            services.forEach(svc => {
              if(svc.item_slug === card.item_slug) include = false;
            })
            if(include) services.push(card);
          })
          this.services = services;
          this.loading = false;
        }
      },
      async getPersonalisedBanner() {
        const payload = {
            user_id: this.$store.getters.user_id,
          }
        const res = await axios.post(config.api_env + '/application/api/u/marketplace/get-banners', payload, config.options)
        if (res.data.success && res.data.banners) {
          this.personalisedBannerData = res.data.banners
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
        }
      },
      openPersonaliseModal() {
        this.$bvModal.show("personalise-modal");
      },
      onModalHidden() {
        const url = new URL(window.location);
        url.searchParams.delete('personalise_banner');
        window.history.replaceState({}, document.title, url.pathname + url.search);
      },
      extractProductsFromNav(nav) {
        nav.forEach(navItem => {
          if(this.products.hasOwnProperty(navItem.item_slug)) this.products[navItem.item_slug] = true;
          if(navItem.hasOwnProperty('sub_items')) {
            navItem.sub_items.forEach(subItem => {
              if(this.products.hasOwnProperty(subItem.item_slug)) this.products[subItem.item_slug] = true;
            })
          }
        })
      },
      async getBookings(){
        try {
          let res = await this.api({
            path: "api/u/home-page/get-booking-widget",
          });
          if (res.success) {
            this.bookings = res.bookings;
            EventBus.$emit("setBookingReminders", this.bookings);

          }
          this.bookingsLoading = false;
        } catch (e) {
          this.bookingsLoading = false;
        }

      }
    },
    computed: {
      ...mapGetters(["nav","sideNav","skin"]),
      messageToDisplay() {
        return this.company_homepage_message ? atob(this.company_homepage_message) : null;
      },
      showDcs() {
        if(!this.products.digitalClinicsGeneric) return false;
        if(!this.optionalTag) return true;
        return this.optionalTag.length === 0;

      },
      componentText() {
        return this.getText.dfd;
      }
    },
    watch: {
      '$route.query.personalise_banner'(newVal) {
        if (newVal === 'true') {
          this.openPersonaliseModal();
        }
      }
    }
};
</script>
<style lang="less">
#DigitalFrontDoor {
    transition: background-color 1s ease;

    #HomeDigitalClinicsBanner {
        margin-top: 5px !important;
        margin-bottom: 10px;
    }
    .home-top-container {
      max-width: 1300px;
      margin: auto;
    }

    .container {
      width: 98% !important;
      max-width: 2000px !important;
      margin: auto;
    }
    .banner-card-container {
      width: 90% !important;
    }
    .home-title {
        font-size: 2.4rem;
        font-family: "FilsonProBold", sans-serif;
        text-align: left;
        margin-bottom: 10px;
    }

    .home-title-underline {
        margin-left: 5px;
        height: 3px;
        width: 50px;
    }
   #HomeDigitalClinicsBanner {
     margin-top: 30px;
   }

   .view-services-btn {
    display: block;
    max-width: 300px;
    background-color: #192550;
    padding: 16px 20px;
    color: #FFFFFF;
    border: 0;
    font-size: 2rem;
    font-weight: 900;
    border-radius: 5px;
    margin: 52px auto 32px;

      .arrow-container {
        padding: 4px 8px;
        background-color: #FFFFFF;
        border-radius: 5px;
        color: #122130;
        margin-left: 20px;
      }

      .fa {
        font-size: 1.8rem;
        color: #122130;
      }
   }
}
@media only screen and (max-width: 767px) {
  #DigitalFrontDoor {
    .container {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
    }
    .banner-holder {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
    }
  }
}
</style>